import styled from 'styled-components'

interface ContainerProps {
  hasPinError: boolean
}

export const Container = styled.div<ContainerProps>`
  border: ${({ hasPinError }) => (hasPinError ? '2px solid #FF4D4C' : '1px solid #C1C1C1')};
  padding: 20px 20px 0;
  border-radius: 10px;

  .pincode-input-container {
    .pincode-input-text {
      border-bottom: 0.3rem solid !important;
      font-size: 30px !important;
      font-weight: bold !important;
      border-bottom-right-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
    }
  }
`

export const WrapperButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  > button {
    padding: 0;
  }

  > button:first-child {
    margin-right: 20px;
  }
`